export const calculateAvgHealthPercentage = (dimensionResult) => {
  const totalValue = Object.values(dimensionResult).reduce((accumulator, element) => {
    return accumulator + element.value;
  }, 0);
  const numberOfElements = Object.keys(dimensionResult).length;
  const multiplier = 10;

  return ((totalValue * multiplier) / numberOfElements).toFixed(1);
}
